import { render, staticRenderFns } from "./infiniteloading.vue?vue&type=template&id=19baa5af&"
import script from "./infiniteloading.vue?vue&type=script&lang=js&"
export * from "./infiniteloading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports